let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hwhDA")).then(() => parcelRequire('lWLYN'));